import React from 'react'
import { ToolkitContentPage } from '../../components/ToolkitContentPage'
import toolkitContent from '../../data/toolkitContent.json'

export const CommunityEducationPage: React.FC = () => {
  // Find the Community Education content from our JSON data
  const communityContent = toolkitContent.find(
    (item) => item.title === 'Community Education'
  )

  if (!communityContent) {
    return (
      <div className="text-center py-12">
        <h1 className="text-2xl font-bold text-[#3C2416] mb-4">
          Page Not Found
        </h1>
        <p className="text-[#713d43]">
          The requested content could not be found.
        </p>
      </div>
    )
  }

  const breadcrumbs = [
    { label: 'Toolkit', path: '/toolkit' },
    { label: 'Community', path: '/toolkit/community' },
    { label: 'Education', path: '/toolkit/community/education', isActive: true }
  ]

  return (
    <ToolkitContentPage
      title={communityContent.title}
      htmlContent={communityContent.html_content}
      breadcrumbs={breadcrumbs}
    />
  )
}
